import { Injectable } from '@angular/core';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateChangeService } from '@fi-shared/fi-state-proxy/fi-state-change.service';
import { ILocalSearchData } from '@fi-shared/fi-local-search2/fi-local-search';

@Injectable()
export class LocalSearchStorageService {
    constructor(
        private sessionService: SessionService,
        private stateService: FiStateService,
        private fiStateChangeService: FiStateChangeService,
    ) {
        setTimeout(() => {
            this.fiStateChangeService.onStart$.subscribe((transition) => {
                const params = this.sessionService.getLastLocalSearchData(),
                    toState = transition.to();

                if (params.Module) {
                    var routes = Array.isArray(params.Module) ? params.Module : [params.Module];
                    for (var i = 0; i < routes.length; i++) {
                        if (
                            (params.ModuleExactMatch && toState.name === routes[i]) ||
                            (!params.ModuleExactMatch && toState.name.indexOf(routes[i]) === 0)
                        ) {
                            return;
                        }
                    }
                }
                params.Reset();
                this.SaveSearchParameters(params);
            });
        });
    }

    GetLastSearchParameters(): ILocalSearchData {
        return this.sessionService.getLastLocalSearchData();
    }

    SaveSearchParameters(searchParams: ILocalSearchData) {
        this.sessionService.setLocalSearchData(searchParams);
    }
}
